import React from 'react';

const Footer = ({ onOpenEnquiry, onOpenApply }) => {
  return (
    <footer className="site-footer simple-footer">
      <div className="footer-container simple-footer-container">
        <p className="copyright-text">
          © {new Date().getFullYear()} Online Manipal. All Rights Reserved.
        </p>

        <div className="footer-cta-buttons">
          <button className="btn-secondary footer-btn" onClick={onOpenEnquiry}>
            Enquire Now
          </button>
          <button className="btn-primary footer-btn" onClick={onOpenApply}>
            Apply Now
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
